import { useDispatch } from "react-redux";
import { immunizations } from "./immunizations";
import { setImmunizations } from "../../../../entities/patient-stats/immunizations/immunizations.slice";

export const useGetImmunizations = () => {
  const dispatch = useDispatch();

  const getImmunizationsByPatientId = async (patientId: string) => {
    const res = await new Promise((resolve) => {
      setTimeout(() => {
        const filtered = immunizations.filter(
          (p) => String(p.patientId) === patientId,
        );
        resolve(filtered[0]);
      }, 400);
    }); // имитация API

    dispatch(setImmunizations(res)); // сохраняем в сторе
  };

  return {
    getImmunizationsByPatientId,
  };
};
